(function IIFE() {
    'use strict';

    /////////////////////////////

    function NotificationFactory($resource, Config) {
        'ngInject';

        return $resource(Config.HAUSSMANN_HOST + '/_ah/api/lumsites/v1/notification/:methodKey', {}, {
            list: {
                isArray: false,
                method: 'POST',
                params: {
                    methodKey: 'list',
                },
            },

            send: {
                isArray: false,
                method: 'POST',
                params: {
                    methodKey: 'send',
                },
            },

            setAllAsRead: {
                isArray: false,
                method: 'POST',
                params: {
                    methodKey: 'setAllAsRead',
                },
            },

            setAsRead: {
                isArray: false,
                method: 'DELETE',
                params: {
                    methodKey: 'delete',
                },
            },
        });
    }

    /////////////////////////////

    angular.module('Factories').factory('NotificationFactory', NotificationFactory);
})();
